import { TileLayerEnum } from '../../../../../core/enums/tileLayer.enums';
import { mapTileUrlList } from '../mapTileUrlList';

export function currentTileLayerSetter(currentTileUrl: number) {
    switch (currentTileUrl) {
        case TileLayerEnum.GoogleMapHybrid:
            return mapTileUrlList.googleMapsHybrid;
        case TileLayerEnum.GoogleMapsSatellite:
            return mapTileUrlList.googleMapsSatellite;
        case TileLayerEnum.GoogleMapsRoads:
            return mapTileUrlList.googleMapsRoads;
        case TileLayerEnum.ArcGIS:
            return mapTileUrlList.arcGIS;
        case TileLayerEnum.OpenStreetMap:
            return mapTileUrlList.openStreetMap;
        case TileLayerEnum.OpenStreetMap2:
            return mapTileUrlList.openStreetMap2;
        case TileLayerEnum.ThunderForestTopography:
            return mapTileUrlList.thunderForestTopography;
        case TileLayerEnum.TopographyMap:
            return mapTileUrlList.topographyMap;
        case TileLayerEnum.StadiaMap:
            return mapTileUrlList.stadiaMap;
        case TileLayerEnum.WikiMediaMap:
            return mapTileUrlList.wikiMediaMap;
        // case TileLayerEnum.BingMap:
        //     return mapTileUrlList.bingMapSatellite;
        default:
            return mapTileUrlList.googleMapsHybrid;
    }
}
